import { putResendOTP, RequestOTPResponse } from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { Self } from '../common';

function* putResendOTPRequest(
  self: Self
): Generator<Promise<FlowReturn<RequestOTPResponse>>> {
  self.isLoading = true;
  try {
    const response = yield putResendOTP({
      otpId: self.otp.otpId,
      otpRef: self.otp.otpRef,
    });
    const { data, status } = (response as RequestOTPResponse).data;
    if (status.code === 1000) {
      self.otp.reset();
      self.otp = { ...self.otp, ...data };
      return Promise.resolve(ResponseMessage.OK);
    }
    self.alert.title = status.messages[0];
    self.alert.open = true;
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default putResendOTPRequest;
